import { ProductType } from "@obg/ngx.core";
import { Route } from "@obg/ngx.router";

export interface PlayForFunOptions {
	loggedIn: boolean;
	loggedOut: boolean;
}

export interface LicenseGroups {
	providers: string[];
	key: string;
}

export interface GameChangeToken {
	currentRoute: Route;
	isAuthenticated: boolean;
	firstLoad: boolean;
	product: ProductType;
}

export interface RouteChangeToken {
	currentRoute: Route;
	productType: ProductType;
}

export enum GameWindowMode {
	Single = 1,
	Dual = 2,
	Quad = 4,
}
